module.exports = __webpack_public_path__ + "b88769d4118517e64473f019e6698eaa.webp";